import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Icon({ className, isAscending, isDescending }: Props) {
  return isAscending ? (
    <svg viewBox="0 0 7.107 9.754" className={className}>
      <path
        d="M1.78,8.1H7.612a.589.589,0,0,0,.417-1L5.112,4.177a.586.586,0,0,0-.831,0L1.364,7.093A.589.589,0,0,0,1.78,8.1ZM8.028,10.67,5.112,13.585a.586.586,0,0,1-.831,0L1.364,10.67a.589.589,0,0,1,.417-1H7.612A.589.589,0,0,1,8.028,10.67Z"
        transform="translate(-1.143 -4.005)"
        fill="#b2b2b2"
      />
      <path
        d="M6.51,0H.6A.6.6,0,0,0,.176,1.019L3.132,3.975a.594.594,0,0,0,.842,0L6.93,1.019A.6.6,0,0,0,6.51,0Z"
        transform="translate(7.108 4.15) rotate(180)"
        fill="#707070"
      />
    </svg>
  ) : isDescending ? (
    <svg viewBox="0 0 7.107 9.754" className={className}>
      <g transform="translate(24105.059 20767.377)">
        <path
          d="M1.78,9.665H7.612a.589.589,0,0,1,.417,1L5.112,13.585a.586.586,0,0,1-.831,0L1.364,10.67A.589.589,0,0,1,1.78,9.665ZM8.028,7.093,5.112,4.177a.586.586,0,0,0-.831,0L1.364,7.093a.589.589,0,0,0,.417,1H7.612A.589.589,0,0,0,8.028,7.093Z"
          transform="translate(-24106.201 -20771.381)"
          fill="#b2b2b2"
        />
        <path
          d="M7.7,8.154H1.789a.6.6,0,0,1-.422-1.019L4.323,4.179a.594.594,0,0,1,.842,0L8.121,7.136A.6.6,0,0,1,7.7,8.154Z"
          transform="translate(-24096.76 -20753.619) rotate(180)"
          fill="#707070"
        />
      </g>
    </svg>
  ) : (
    <svg viewBox="0 0 7.01 9.754" className={className}>
      <path
        d="M1.78,9.665H7.612a.589.589,0,0,1,.417,1L5.112,13.585a.586.586,0,0,1-.831,0L1.364,10.67A.589.589,0,0,1,1.78,9.665ZM8.028,7.093,5.112,4.177a.586.586,0,0,0-.831,0L1.364,7.093a.589.589,0,0,0,.417,1H7.612A.589.589,0,0,0,8.028,7.093Z"
        transform="translate(-1.191 -4.004)"
        fill="#b2b2b2"
      />
    </svg>
  );
}

export { Icon };
